import { render, staticRenderFns } from "./TeacherEdit.vue?vue&type=template&id=4b3bce9e&scoped=true&"
import script from "./TeacherEdit.vue?vue&type=script&lang=js&"
export * from "./TeacherEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b3bce9e",
  null
  
)

export default component.exports